type IconProps = React.HTMLAttributes<SVGElement>

interface BarChartIconProps extends IconProps {
  highlightedBar?: number
}

const heights = [3, 6, 10, 6, 3]
const yValues = [7, 4, 0, 4, 7]

// Ensure Tailwind includes these classes in the build
// fill-green-60
// fill-green-30

export function BarChartIcon({
  highlightedBar = 3,
  ...rest
}: BarChartIconProps) {
  return (
    <svg width="19" height="10" viewBox="0 0 19 10" fill="none" {...rest}>
      {Array.from({ length: 5 }, (_, i) => {
        const isHighlighted = i + 1 === highlightedBar
        return (
          <rect
            key={i}
            y={yValues[i]}
            x={i * 4}
            width="3"
            height={heights[i]}
            className={`fill-green-${isHighlighted ? '30' : '60'}`}
          />
        )
      })}
    </svg>
  )
}
